export const translations = {
  tr: {
    nav: {
      home: 'Ana Sayfa',
      about: 'Hakkımızda',
      services: 'Hizmetlerimiz',
      contact: 'İletişim'
    },
    home: {
      hero: {
        title: 'Veriyi Anlamlandırıyoruz',
        subtitle: 'Stratejiye Dönüştürüyoruz',
        description: '2019 yılından bu yana Türkiye\'de faaliyet gösteren bağımsız bir pazar araştırma firması',
        cta: 'Hizmetlerimizi Keşfedin'
      },
      qualitative: {
        title: 'Kalitatif Araştırmalar',
        subtitle: 'Tüketiciyi Anlamanın En Derin Yolu',
        description: 'Kalitatif araştırmalarımız, insanların davranışlarını, motivasyonlarını, algılarını ve duygularını keşfetmeyi amaçlar.',
        methods: 'Yöntemlerimiz:',
        methodList: [
          'Derinlemesine mülakatlar',
          'Odak grup görüşmeleri',
          'Etnografik araştırmalar',
          'Kullanıcı deneyimi (UX) testleri',
          'Günlük/diary çalışmaları'
        ],
        benefits: 'Neler Sağlıyoruz?',
        benefitList: [
          'Tüketici davranışlarının ardındaki gerçek sebepleri anlama',
          'Marka algısını detaylı şekilde ölçme',
          'Ürün/hizmet geliştirme süreçlerine içgörü sağlama',
          'Stratejik iletişim önerileri oluşturma'
        ]
      },
      quantitative: {
        title: 'Kantitatif Araştırmalar',
        subtitle: 'Ölçülebilir, Güvenilir, İstatistiksel Sonuçlar',
        description: 'Kantitatif araştırmalarımız ile geniş örneklem gruplarından elde edilen verileri analiz ederek ölçülebilir sonuçlar ortaya koyuyoruz.',
        methods: 'Yöntemlerimiz:',
        methodList: [
          'Online ve yüz yüze anketler',
          'CATI (Bilgisayar destekli telefon görüşmeleri)',
          'CAWI (Bilgisayar destekli web anketleri)',
          'CAPI (Tablet destekli saha çalışmaları)'
        ],
        benefits: 'Neler Sağlıyoruz?',
        benefitList: [
          'Pazar büyüklüğü ve potansiyel analizi',
          'Müşteri memnuniyeti ve sadakat ölçümleri',
          'Marka bilinirliği ve konumlandırma araştırmaları',
          'Ürün testleri ve fiyatlandırma analizleri',
          'Segmentasyon çalışmaları'
        ]
      },
      why: {
        title: 'Neden Biz?',
        reason1: 'Alanında uzman araştırma ekibi',
        reason2: 'İleri düzey analiz teknikleri',
        reason3: 'Güçlü raporlama ve sunum yetkinliği',
        reason4: 'Şeffaf, hızlı ve sonuç odaklı yaklaşım'
      },
      cta: {
        title: 'Sizin İçin En Doğru Araştırma Yaklaşımını Belirleyelim',
        description: 'Projeleriniz için en uygun araştırma yöntemini belirlemek üzere bizimle iletişime geçebilir, ihtiyaçlarınıza özel çözüm önerileri alabilirsiniz.',
        button: 'İletişime Geçin',
        tagline: 'Doğru Veri → Güçlü Strateji → Başarılı Sonuçlar'
      }
    },
    about: {
      title: 'Hakkımızda',
      content1: '2019 yılından bu yana Türkiye\'de faaliyet gösteren bağımsız bir pazar araştırma firması olarak, markaların stratejik karar süreçlerini güçlendiren kapsamlı nitel ve nicel araştırma hizmetleri sunuyoruz. Ülkemizin farklı bölgelerinde gerçekleştirdiğimiz projelerle, yerel dinamikleri derinlemesine anlayan ve sektörlere özel çözümler üreten güvenilir bir araştırma ortağıyız.',
      content2: 'Uzman tedarik, saha ve proje yönetimi ekiplerimiz sayesinde; her ölçekte marka için yüksek kalite standartlarına uygun, hızlı ve güvenilir araştırma süreçleri yürütüyoruz. Kapsamlı panellerimiz ve tescilli metodolojilerimiz; çeşitli, spesifik ve ulaşılması zor hedef kitlelere etkin bir şekilde erişmemizi sağlıyor.',
      content3: 'Reaksiyon Araştırma olarak; araştırma tasarımı, saha uygulamaları ve veri analizini kapsayan uçtan uca çözümler geliştiriyor, müşterilerimizin ihtiyaçlarına özel, aksiyona dönüştürülebilir içgörüler sunuyoruz. Amacımız, Türkiye\'nin hızla değişen pazar koşullarında markalara net, tutarlı ve stratejik bilgiyle rehberlik etmek.'
    },
    services: {
      title: 'Hizmetlerimiz',
      qualitative: {
        title: 'Kalitatif Araştırmalar',
        subtitle: 'Tüketiciyi Anlamanın En Derin Yolu'
      },
      quantitative: {
        title: 'Kantitatif Araştırmalar',
        subtitle: 'Ölçülebilir, Güvenilir, İstatistiksel Sonuçlar'
      }
    },
    contact: {
      title: 'İletişim',
      subtitle: 'Bizimle İletişime Geçin',
      form: {
        name: 'Ad Soyad',
        email: 'E-posta',
        message: 'Mesajınız',
        send: 'Gönder',
        success: 'Mesajınız başarıyla gönderildi!',
        error: 'Bir hata oluştu. Lütfen tekrar deneyin.'
      },
      info: {
        address: 'Adres',
        addressText: 'Bahçeler Sokak 19/1 Kat:4, Mecidiyeköy - Şişli - İstanbul',
        email: 'E-posta'
      }
    },
    footer: {
      tagline: 'Doğru Veri → Güçlü Strateji → Başarılı Sonuçlar',
      quickLinks: 'Hızlı Bağlantılar',
      legal: 'Yasal',
      privacy: 'Gizlilik Politikası',
      terms: 'Kullanım Koşulları',
      kvkk: 'KVKK Aydınlatma Metni',
      cookie: 'Çerez Politikası',
      rights: 'Tüm hakları saklıdır.'
    },
    cookie: {
      title: 'Çerez Politikası',
      message: 'Web sitemiz, kullanıcı deneyimini iyileştirmek için çerezler kullanmaktadır. Sitemizi kullanmaya devam ederek KVKK kapsamında çerez kullanımını kabul etmiş olursunuz.',
      accept: 'Kabul Et',
      reject: 'Reddet',
      settings: 'Ayarlar'
    },
    privacy: {
      title: 'Gizlilik Politikası ve KVKK Aydınlatma Metni',
      subtitle: 'Kişisel verilerinizin gizliliğine ve güvenliğine büyük önem veriyoruz',
      section1: {
        title: '1. Veri Sorumlusu',
        content: 'Bu web sitesini işleten ve kişisel verilerinizi işleyen veri sorumlusu:'
      },
      section2: {
        title: '2. Toplanan Kişisel Veriler',
        content: 'Web sitemiz üzerinden aşağıdaki veri kategorileri işlenebilir:',
        items: [
          'İletişim formu aracılığıyla ilettiğiniz ad, soyad, e-posta adresi, telefon numarası',
          'Çerezler üzerinden toplanan ziyaretçi trafiği ve kullanım bilgileri',
          'Tarayıcı ve cihaz bilgileri',
          'Hizmet taleplerine ilişkin bilgiler'
        ]
      },
      section3: {
        title: '3. Kişisel Verilerin İşlenme Amaçları',
        content: 'Toplanan kişisel veriler, aşağıdaki amaçlarla işlenebilir:',
        items: [
          'Taleplerinizi yanıtlamak ve sizinle iletişim kurmak',
          'Hizmetlerimizi geliştirmek ve kullanıcı deneyimini iyileştirmek',
          'Web sitesi güvenliğini sağlamak',
          'Pazarlama ve bilgilendirme amaçlı ileti gönderimi (açık rızanız olması durumunda)',
          'Yasal yükümlülüklerimizi yerine getirmek'
        ]
      },
      section4: {
        title: '4. Kişisel Verilerin Aktarılması',
        content: 'Kişisel verileriniz:',
        items: [
          'Yalnızca hizmet aldığımız güvenilir iş ortakları ve tedarikçilerle',
          'Yasal zorunluluk halinde yetkili kamu kurumlarıyla paylaşılabilir'
        ],
        note: 'Yurtdışına veri aktarımı yapılmamaktadır.'
      },
      section5: {
        title: '5. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebebi',
        content: 'Kişisel verileriniz; web sitemizdeki formlar, çerezler, e-posta iletişimi gibi yöntemlerle, KVKK m.5/2 kapsamında "sözleşmenin kurulması/ifası", "meşru menfaat", "kanuni zorunluluk" veya açık rıza hukuki sebeplerine dayanarak işlenmektedir.'
      },
      section6: {
        title: '6. KVKK Kapsamındaki Haklarınız',
        content: 'KVKK\'nın 11. maddesi uyarınca:',
        items: [
          'Kişisel verilerinize erişme',
          'Düzeltilmesini talep etme',
          'Silinmesini/anonimleştirilmesini isteme',
          'İşlemeye itiraz etme',
          'İşlenen verilerin amacı doğrultusunda kullanılmasını talep etme'
        ],
        note: 'Başvurularınızı bizimle iletişime geçerek iletebilirsiniz.'
      }
    },
    terms: {
      title: 'Kullanım Koşulları',
      subtitle: 'Web sitemizi kullanarak aşağıdaki koşulları kabul etmiş olursunuz',
      intro: 'Reaksiyon Araştırma web sitesini kullanarak, aşağıdaki kullanım koşullarını kabul etmiş sayılırsınız. Lütfen siteyi kullanmadan önce bu koşulları dikkatlice okuyun.',
      sections: [
        {
          title: 'Web Sitesinin Kullanımı',
          content: 'Bu web sitesi, Reaksiyon Araştırma tarafından sunulan hizmetler hakkında bilgi vermek amacıyla oluşturulmuştur. Site içeriği yalnızca bilgilendirme amaçlıdır.',
          items: []
        },
        {
          title: 'Fikri Mülkiyet Hakları',
          content: 'Bu web sitesinde yer alan tüm içerik, tasarım, logo, metin, görsel ve diğer materyaller Reaksiyon Araştırma\'nın mülkiyetindedir ve telif hakkı yasaları ile korunmaktadır.',
          items: [
            'Site içeriği izinsiz kopyalanamaz, çoğaltılamaz veya dağıtılamaz',
            'Ticari amaçlarla kullanılamaz',
            'Kaynak gösterilmeden alıntı yapılamaz'
          ]
        },
        {
          title: 'Sorumluluk Reddi',
          content: 'Reaksiyon Araştırma, web sitesinde yer alan bilgilerin doğruluğu ve güncelliği konusunda azami özeni göstermekle birlikte:',
          items: [
            'Bilgilerdeki olası hatalardan sorumlu tutulamaz',
            'Site içeriğinin kullanımından doğabilecek zararlardan sorumlu değildir',
            'Üçüncü parti web sitelerine yapılan bağlantılardan sorumlu tutulamaz'
          ]
        },
        {
          title: 'Gizlilik',
          content: 'Kişisel verilerinizin işlenmesi hakkında detaylı bilgi için Gizlilik Politikamızı inceleyebilirsiniz.',
          items: []
        },
        {
          title: 'Değişiklikler',
          content: 'Reaksiyon Araştırma, bu kullanım koşullarını önceden haber vermeksizin değiştirme hakkını saklı tutar. Değişiklikler sitede yayınlandığı andan itibaren geçerli olacaktır.',
          items: []
        },
        {
          title: 'Uygulanacak Hukuk',
          content: 'Bu kullanım koşulları Türkiye Cumhuriyeti yasalarına tabidir. Ortaya çıkabilecek uyuşmazlıklarda İstanbul mahkemeleri ve icra daireleri yetkilidir.',
          items: []
        }
      ],
      contact: {
        title: 'İletişim',
        content: 'Kullanım koşulları hakkında sorularınız için bizimle iletişime geçebilirsiniz:'
      }
    },
    cookiePolicy: {
      title: 'Çerez Politikası',
      subtitle: 'Web sitemizde kullanılan çerezler hakkında bilgilendirme',
      intro: 'Reaksiyon Araştırma olarak, web sitemizde kullanıcı deneyimini iyileştirmek ve site performansını analiz etmek amacıyla çerezler kullanmaktayız. Bu politika, hangi çerezleri kullandığımız ve bunların nasıl yönetileceği hakkında bilgi vermektedir.',
      sections: [
        {
          title: 'Çerez Nedir?',
          content: 'Çerezler, bir web sitesini ziyaret ettiğinizde cihazınıza (bilgisayar, tablet veya mobil cihaz) kaydedilen küçük metin dosyalarıdır. Çerezler, web sitesinin daha verimli çalışmasını ve size özelleştirilmiş içerik sunulmasını sağlar.',
          items: []
        },
        {
          title: 'Kullandığımız Çerez Türleri',
          content: 'Web sitemizde aşağıdaki çerez türlerini kullanmaktayız:',
          items: [
            { name: 'Zorunlu Çerezler', desc: 'Web sitesinin temel işlevlerinin çalışması için gereklidir. Bu çerezler olmadan site düzgün çalışmaz.' },
            { name: 'Performans Çerezleri', desc: 'Ziyaretçilerin siteyi nasıl kullandığını anlamamıza yardımcı olur. Bu bilgiler anonim olarak toplanır.' },
            { name: 'İşlevsellik Çerezleri', desc: 'Dil tercihi gibi seçimlerinizi hatırlayarak daha kişiselleştirilmiş bir deneyim sunar.' },
            { name: 'Analitik Çerezler', desc: 'Google Analytics gibi araçlar aracılığıyla site trafiğini ve kullanıcı davranışlarını analiz eder.' }
          ]
        },
        {
          title: 'Çerezleri Nasıl Kontrol Edebilirsiniz?',
          content: 'Çerezleri kontrol etmek ve yönetmek için tarayıcı ayarlarınızı kullanabilirsiniz:',
          items: [
            { name: '', desc: 'Tarayıcınızın ayarlar bölümünden çerezleri silebilir veya engelleyebilirsiniz' },
            { name: '', desc: 'Çoğu tarayıcı, çerezleri otomatik olarak kabul edecek şekilde ayarlıdır. Bu ayarı değiştirebilirsiniz' },
            { name: '', desc: 'Çerezleri devre dışı bırakırsanız, web sitesinin bazı özellikleri düzgün çalışmayabilir' }
          ]
        },
        {
          title: 'Üçüncü Taraf Çerezler',
          content: 'Web sitemizde Google Analytics gibi üçüncü taraf hizmet sağlayıcıların çerezleri de kullanılabilir. Bu çerezler, site performansını ölçmek ve iyileştirmek için kullanılır.',
          items: []
        },
        {
          title: 'Politika Güncellemeleri',
          content: 'Bu çerez politikasını zaman zaman güncelleyebiliriz. Değişiklikler bu sayfada yayınlanacaktır.',
          items: []
        }
      ],
      note: 'Web sitemizi kullanmaya devam ederek çerez kullanımını kabul etmiş olursunuz.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      contact: 'Contact'
    },
    home: {
      hero: {
        title: 'We Make Sense of Data',
        subtitle: 'We Transform It Into Strategy',
        description: 'An independent market research firm operating in Turkey since 2019',
        cta: 'Explore Our Services'
      },
      qualitative: {
        title: 'Qualitative Research',
        subtitle: 'The Deepest Way to Understand Consumers',
        description: 'Our qualitative research aims to explore people\'s behaviors, motivations, perceptions, and emotions.',
        methods: 'Our Methods:',
        methodList: [
          'In-depth interviews',
          'Focus group discussions',
          'Ethnographic research',
          'User experience (UX) testing',
          'Diary studies'
        ],
        benefits: 'What We Provide?',
        benefitList: [
          'Understanding the real reasons behind consumer behavior',
          'Measuring brand perception in detail',
          'Providing insights for product/service development',
          'Creating strategic communication recommendations'
        ]
      },
      quantitative: {
        title: 'Quantitative Research',
        subtitle: 'Measurable, Reliable, Statistical Results',
        description: 'With our quantitative research, we analyze data obtained from large sample groups and produce measurable results.',
        methods: 'Our Methods:',
        methodList: [
          'Online and face-to-face surveys',
          'CATI (Computer-assisted telephone interviews)',
          'CAWI (Computer-assisted web interviews)',
          'CAPI (Tablet-assisted field studies)'
        ],
        benefits: 'What We Provide?',
        benefitList: [
          'Market size and potential analysis',
          'Customer satisfaction and loyalty measurements',
          'Brand awareness and positioning research',
          'Product testing and pricing analysis',
          'Segmentation studies'
        ]
      },
      why: {
        title: 'Why Us?',
        reason1: 'Expert research team',
        reason2: 'Advanced analysis techniques',
        reason3: 'Strong reporting and presentation capabilities',
        reason4: 'Transparent, fast, and results-oriented approach'
      },
      cta: {
        title: 'Let\'s Determine the Right Research Approach for You',
        description: 'You can contact us to determine the most suitable research method for your projects and receive customized solution proposals.',
        button: 'Get in Touch',
        tagline: 'Right Data → Strong Strategy → Successful Results'
      }
    },
    about: {
      title: 'About Us',
      content1: 'As an independent market research firm operating in Turkey since 2019, we offer comprehensive qualitative and quantitative research services that strengthen brands\' strategic decision-making processes. With projects carried out in different regions of our country, we are a reliable research partner that deeply understands local dynamics and produces sector-specific solutions.',
      content2: 'Thanks to our expert procurement, field, and project management teams, we conduct fast and reliable research processes that comply with high-quality standards for brands of all sizes. Our comprehensive panels and proprietary methodologies enable us to effectively reach diverse, specific, and hard-to-reach target audiences.',
      content3: 'As Reaksiyon Araştırma, we develop end-to-end solutions covering research design, field applications, and data analysis, offering actionable insights tailored to our clients\' needs. Our goal is to guide brands with clear, consistent, and strategic information in Turkey\'s rapidly changing market conditions.'
    },
    services: {
      title: 'Our Services',
      qualitative: {
        title: 'Qualitative Research',
        subtitle: 'The Deepest Way to Understand Consumers'
      },
      quantitative: {
        title: 'Quantitative Research',
        subtitle: 'Measurable, Reliable, Statistical Results'
      }
    },
    contact: {
      title: 'Contact',
      subtitle: 'Get in Touch with Us',
      form: {
        name: 'Full Name',
        email: 'Email',
        message: 'Your Message',
        send: 'Send',
        success: 'Your message has been sent successfully!',
        error: 'An error occurred. Please try again.'
      },
      info: {
        address: 'Address',
        addressText: 'Bahçeler Street 19/1 Floor:4, Mecidiyeköy - Şişli - Istanbul',
        email: 'Email'
      }
    },
    footer: {
      tagline: 'Right Data → Strong Strategy → Successful Results',
      quickLinks: 'Quick Links',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use',
      kvkk: 'GDPR Notice',
      cookie: 'Cookie Policy',
      rights: 'All rights reserved.'
    },
    cookie: {
      title: 'Cookie Policy',
      message: 'Our website uses cookies to improve user experience. By continuing to use our site, you accept the use of cookies under GDPR.',
      accept: 'Accept',
      reject: 'Reject',
      settings: 'Settings'
    },
    privacy: {
      title: 'Privacy Policy and GDPR Notice',
      subtitle: 'We attach great importance to the privacy and security of your personal data',
      section1: {
        title: '1. Data Controller',
        content: 'The data controller operating this website and processing your personal data:'
      },
      section2: {
        title: '2. Collected Personal Data',
        content: 'The following data categories may be processed through our website:',
        items: [
          'Name, surname, email address, phone number submitted through the contact form',
          'Visitor traffic and usage information collected through cookies',
          'Browser and device information',
          'Information related to service requests'
        ]
      },
      section3: {
        title: '3. Purposes of Processing Personal Data',
        content: 'Collected personal data may be processed for the following purposes:',
        items: [
          'To respond to your requests and communicate with you',
          'To improve our services and enhance user experience',
          'To ensure website security',
          'To send marketing and informational messages (with your explicit consent)',
          'To fulfill our legal obligations'
        ]
      },
      section4: {
        title: '4. Transfer of Personal Data',
        content: 'Your personal data may be shared:',
        items: [
          'Only with trusted business partners and suppliers from whom we receive services',
          'With authorized public institutions in case of legal obligation'
        ],
        note: 'No international data transfer is made.'
      },
      section5: {
        title: '5. Method and Legal Basis for Collecting Personal Data',
        content: 'Your personal data is processed through methods such as forms on our website, cookies, and email communication, based on legal grounds including "contract performance", "legitimate interest", "legal obligation", or explicit consent under GDPR.'
      },
      section6: {
        title: '6. Your Rights Under GDPR',
        content: 'Under GDPR, you have the right to:',
        items: [
          'Access your personal data',
          'Request correction',
          'Request deletion/anonymization',
          'Object to processing',
          'Request data portability'
        ],
        note: 'You can submit your requests by contacting us.'
      }
    },
    terms: {
      title: 'Terms of Use',
      subtitle: 'By using our website, you accept the following terms',
      intro: 'By using the Reaksiyon Araştırma website, you are deemed to have accepted the following terms of use. Please read these terms carefully before using the site.',
      sections: [
        {
          title: 'Use of the Website',
          content: 'This website has been created to provide information about services offered by Reaksiyon Araştırma. The site content is for informational purposes only.',
          items: []
        },
        {
          title: 'Intellectual Property Rights',
          content: 'All content, design, logo, text, visuals, and other materials on this website are the property of Reaksiyon Araştırma and are protected by copyright laws.',
          items: [
            'Site content cannot be copied, reproduced, or distributed without permission',
            'Cannot be used for commercial purposes',
            'Cannot be quoted without attribution'
          ]
        },
        {
          title: 'Disclaimer',
          content: 'While Reaksiyon Araştırma exercises maximum care regarding the accuracy and currency of information on the website:',
          items: [
            'Cannot be held responsible for possible errors in information',
            'Not responsible for damages that may arise from the use of site content',
            'Cannot be held responsible for links to third-party websites'
          ]
        },
        {
          title: 'Privacy',
          content: 'For detailed information about the processing of your personal data, please review our Privacy Policy.',
          items: []
        },
        {
          title: 'Changes',
          content: 'Reaksiyon Araştırma reserves the right to change these terms of use without prior notice. Changes will be effective from the moment they are published on the site.',
          items: []
        },
        {
          title: 'Applicable Law',
          content: 'These terms of use are subject to the laws of the Republic of Turkey. Istanbul courts and enforcement offices are authorized for any disputes that may arise.',
          items: []
        }
      ],
      contact: {
        title: 'Contact',
        content: 'For questions about the terms of use, please contact us:'
      }
    },
    cookiePolicy: {
      title: 'Cookie Policy',
      subtitle: 'Information about cookies used on our website',
      intro: 'As Reaksiyon Araştırma, we use cookies on our website to improve user experience and analyze site performance. This policy provides information about which cookies we use and how they can be managed.',
      sections: [
        {
          title: 'What is a Cookie?',
          content: 'Cookies are small text files saved to your device (computer, tablet, or mobile device) when you visit a website. Cookies enable the website to work more efficiently and provide you with personalized content.',
          items: []
        },
        {
          title: 'Types of Cookies We Use',
          content: 'We use the following types of cookies on our website:',
          items: [
            { name: 'Necessary Cookies', desc: 'Required for the basic functions of the website to work. The site will not function properly without these cookies.' },
            { name: 'Performance Cookies', desc: 'Help us understand how visitors use the site. This information is collected anonymously.' },
            { name: 'Functionality Cookies', desc: 'Remember your choices such as language preference to provide a more personalized experience.' },
            { name: 'Analytical Cookies', desc: 'Analyze site traffic and user behavior through tools like Google Analytics.' }
          ]
        },
        {
          title: 'How to Control Cookies?',
          content: 'You can use your browser settings to control and manage cookies:',
          items: [
            { name: '', desc: 'You can delete or block cookies from your browser settings section' },
            { name: '', desc: 'Most browsers are set to accept cookies automatically. You can change this setting' },
            { name: '', desc: 'If you disable cookies, some features of the website may not work properly' }
          ]
        },
        {
          title: 'Third-Party Cookies',
          content: 'Third-party service provider cookies, such as Google Analytics, may also be used on our website. These cookies are used to measure and improve site performance.',
          items: []
        },
        {
          title: 'Policy Updates',
          content: 'We may update this cookie policy from time to time. Changes will be published on this page.',
          items: []
        }
      ],
      note: 'By continuing to use our website, you accept the use of cookies.'
    }
  }
};